module.exports = "/assets/8b83a413815bfa8964ed10140ea9b4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VS.png
// module id = 1937
// module chunks = 0